import {ApiError} from '@rambler-id/errors'
import {addUrlParams} from '@rambler-id/url'
import {captureException} from 'utils/sentry'
import {request} from './transport'
import {Errors} from './records'

export interface SuggestRecord {
  albums: number[]
  click_url: string
  created_at: string
  current_screenshot: string
  current_screenshot_small: string
  deleted_at: string
  description: string
  duration: number | string
  id: number
  uuid: string
  is_hd: boolean
  is_processed: boolean
  link: string
  name: string
  origin_size: number
  puid4?: string
  puid5?: string
  puid6?: string
  puid7?: string
  recorded_at?: string
  screenshots: string[]
  tags: string
  updated_at: string
  user_id: number
  view_count: number
}

export const getSuggest = async (
  url: string,
  params: Record<string, any>
): Promise<SuggestRecord[]> => {
  try {
    const response = await request(
      addUrlParams(url.replace(/^\/\//, 'https://'), params),
      {timeout: 10000}
    )
    const {records = [], errors, status} = await response.json()

    if (errors) {
      throw new ApiError({
        message: String(errors),
        code: status
      })
    }

    return records
  } catch (error: any) {
    captureException(error, {url})
    throw error
  }
}

export interface RecordsByFilterParams {
  filterId: number
  albumId?: number
  page?: number
  pageLimit?: number
  orderField?: string
  orderDir?: 'acs' | 'desc' | 'random'
}

interface RecordsByFilterItem {
  albums: number[]
  user_id: number
  id: number
  uuid: string
  name: string
  link: string
  description: string
  tags: string
  duration: number
  originSize: number
  isProcessed: boolean
  isHd: null | boolean
  screenshots: string[]
  currentScreenshot: string
  currentScreenshotSmall: null | string
  views: number
  clickUrl: null | string
  userId: number
  createdAt: string
  updatedAt: string
  deletedAt: string
  metadata: {
    [param: string]: any
  }
}

const API_ORIGIN = process.env.API_ORIGIN
const API_PREFIX = process.env.API_PREFIX

export const getRecordsByFilter = async (
  params: RecordsByFilterParams
): Promise<RecordsByFilterItem[]> => {
  const url = `${API_ORIGIN}${API_PREFIX}/records/byFilter`

  try {
    const response = await request(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({params}),
      timeout: 10000
    })

    const json = await response.json()

    if (json.error && json.error.subtype === 'CACHE_NOT_READY') {
      throw new ApiError(Errors.CACHE_NOT_READY)
    }

    if (!json.result) {
      throw new ApiError(Errors.INVALID_RESPONSE)
    }

    const {
      result: {records = []}
    } = json

    return records
  } catch (error: any) {
    captureException(error, {url, params})
    throw error
  }
}
